// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useRegisterSW } from 'virtual:pwa-register/react';

const intervalMS = 60 * 60 * 1000;

const RegisterSW = () => {
    const updateServiceWorker = useRegisterSW({
        immediate: true,
        onRegisteredSW(swUrl: any, r: any) {
            r &&
                setInterval(async () => {
                    if (r.installing || !navigator) return;

                    if ('connection' in navigator && !navigator.onLine) return;

                    const resp = await fetch(swUrl, {
                        cache: 'no-store',
                        headers: {
                            cache: 'no-store',
                            'cache-control': 'no-cache',
                        },
                    });

                    if (resp?.status === 200) await r.update();
                }, intervalMS);
        },
    });

    return null;
};

export default RegisterSW;
